import { render, staticRenderFns } from "./ClientLastOrders.vue?vue&type=template&id=3fdf3b88"
import script from "./ClientLastOrders.vue?vue&type=script&lang=js"
export * from "./ClientLastOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports